import type { ToastConnectedProps } from '../../../components/toast/types';
import { useCoreSelector } from '../../CoreStore';

export const useToastSlice = {
  getToasts: (): ToastConnectedProps[] => {
    return useCoreSelector(({ toast }) => toast.toasts);
  },
};
